export const enum TalentSectionHiddenFields {
  STATUS = 'STATUS',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  LIMITED_TALENT = 'LIMITED_TALENT',
  ORGANIZATION = 'ORGANIZATION',
  OFFICE = 'OFFICE',
  KAM = 'KAM',
  OVERALL_SCORE = 'OVERALL_SCORE',
  HIRING_DECISION = 'HIRING_DECISION'
}

export const enum ProcessSectionHiddenFields {
  OFFICE = 'OFFICE',
  ORGANIZATION = 'ORGANIZATION',
  LABELS = 'LABELS',
  FEATURES = 'FEATURES',
  TALENTS_COUNT = 'TALENTS_COUNT',
  CREATED_BY = 'CREATED_BY',
  KAM = 'KAM'
}

export const enum UserSectionHiddenFields {
  ORGANIZATION = 'ORGANIZATION',
  ROLE = 'ROLE'
}
